module.exports = "https://www.niulinkcloud.cn/_next/static/media/vip-node.f5301b366a51bdedbfe41e306e26dd94.jpg";